
import React from "react"
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { Tables } from "@/integrations/supabase/types"
import { toast } from "sonner"

type Motoboy = Tables<"motoboys">

export const useMotoboys = () => {
  return useQuery({
    queryKey: ["motoboys"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("motoboys")
        .select("*")
        .eq("is_active", true)
        .order("name")

      if (error) throw error
      return data as Motoboy[]
    }
  })
}

export const useCreateMotoboy = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: Omit<Motoboy, "id" | "created_at" | "updated_at">) => {
      const { data: motoboy, error } = await supabase
        .from("motoboys")
        .insert(data)
        .select()
        .single()

      if (error) throw error
      return motoboy
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["motoboys"] })
      toast.success("Motoboy cadastrado com sucesso!")
    },
    onError: (error) => {
      console.error("Erro ao cadastrar motoboy:", error)
      toast.error("Erro ao cadastrar motoboy")
    }
  })
}
